import { dayjs } from 'util/shared/date';
import { ModelParameters, OptionLeg, OptionLegType } from 'types/riskEngine';
import { RISK_FREE_RATE } from 'util/BlackScholes';

// Shares per option contract; matches the backend's CONTRACT_MULTIPLIER.
export const CONTRACT_MULTIPLIER = 100;

export const DEFAULT_OPTION_LEG: OptionLeg = {
  legType: OptionLegType.LONG_CALL,
  strikePrice: 100,
  premium: 5,
  shares: 1,
  premiumSelectedDate: null,
  daysToExpiration: 0,
};

export const DEFAULT_MODEL_PARAMETERS: ModelParameters = {
  getRiskFreeRate: (_: number) => RISK_FREE_RATE,
  volatility: 0.177,
  lookback: 30,
  baseDate: dayjs().valueOf(),
  useIVSmoothing: true,
};
